import { render, staticRenderFns } from "./logisticsOrder.vue?vue&type=template&id=543a2a40&"
import script from "./logisticsOrder.vue?vue&type=script&lang=js&"
export * from "./logisticsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports